import React from "react";
import ReactDOM from "react-dom/client"; // Use createRoot for React 18+
import App from "./App"; // Import your main App component
import "./assets/styles/fonts.sass";
import "./assets/styles/tailwind-input.css";
// Get the root element from your HTML
const rootElement = document.getElementById("root");

// Create a root and render your App component into it
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error("Root element with ID 'root' not found in the document.");
}
